module.exports = __webpack_public_path__ + "img/ftth_index01.9e038d8e.jpg";